export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-01.4e50e485.jpg";